import { T_LANGUAGE_CODES } from '~/src/Constants/LANGUAGE'

export type T_LANGUAGE_REDUCER = {
  selectedLanguage: T_LANGUAGE_CODES
}

export const INITIAL_STATE: T_LANGUAGE_REDUCER = {
  selectedLanguage: 'hu'
}
